"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentPeriod = (currentPeriod, periods = []) => {
    return periods.find(({ code }) => currentPeriod === code);
};
//# sourceMappingURL=getCurrentPeriod.js.map